module.exports = __webpack_public_path__ + "static/media/caret-square-down.c8ed579a.svg";